import { render, staticRenderFns } from "./TaskFileCard.vue?vue&type=template&id=608e7102"
import script from "./TaskFileCard.vue?vue&type=script&lang=js"
export * from "./TaskFileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports